'use strict';

exports.__esModule = true;
exports.getMarketplaceBaseUrl = exports.getMarketplaceDomain = exports.get = exports.getMarketUrl = exports.setMarketUrl = undefined;

var _fetchApi = require('./fetch-api');

var URL_DOMAIN_REGEX = /^https?:\/\/([^/?#]+)(?:[/?#]|$)/i; // https://stackoverflow.com/a/8498629

var marketUrl = '';

var setMarketUrl = exports.setMarketUrl = function setMarketUrl(url) {
    marketUrl = url;
};

var getMarketUrl = exports.getMarketUrl = function getMarketUrl() {
    return marketUrl;
};

var get = exports.get = function get(url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return (0, _fetchApi.get)(url, Object.assign({}, options, {
        headers: Object.assign({}, options.headers)
    }));
};

var getMarketplaceDomain = exports.getMarketplaceDomain = function getMarketplaceDomain() {
    var matches = marketUrl.match(URL_DOMAIN_REGEX);
    return matches && matches[1];
};

var getMarketplaceBaseUrl = exports.getMarketplaceBaseUrl = function getMarketplaceBaseUrl() {
    var matches = marketUrl.match(URL_DOMAIN_REGEX);
    return matches && matches[0];
};